import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import TimeTrackingEmployeeWeeklyWorkingHours = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeWeeklyWorkingHours;
import TimeTrackingEmployeeWeeklyWorkingHoursData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeWeeklyWorkingHoursData;
import TimeTrackingEmployee = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;

@Injectable({providedIn: 'root'})
export class TimeTrackingEmployeeWeeklyWorkingHoursService extends BaseEndpointService<TimeTrackingEmployeeWeeklyWorkingHours, TimeTrackingEmployeeWeeklyWorkingHoursData> {
  protected override multiSelectTextFields = ['id'] as const;

  public forEmployee(employee: TimeTrackingEmployee) {
    this.endpoint = `/time-tracking/employees/${employee.id}/weekly-working-hours`;
  }
}
